<template>
  <div class="NotificationsList">
    <Page
      :title="type === 'manual' ? $t('NotificationsApp.Manual Notifications') : $t('NotificationsApp.Template Notifications')"
      :primaryAction="getActions()"
      size="fullWidth"
    >

      <Layout>
        <LayoutSection>
          <Card>
            <Tabs
              :tabs="getTabs()"
              v-model="status"
            />
            <!-- <CardSection> -->
            <Filters
              :query.sync="filter"
            />
            <DataTable
              :columns="columns"
              :rows="currentNotifications"
              :row-actions="(n) => getRowActions(n)"
              :emptyText="$t('NotificationsApp.No notifications')"
            > 
              <template v-slot:col:name="{row}">
                <PageLink :href="getEditNotificationUrl(row)">{{row.name}}</PageLink>
              </template>
            </DataTable>

            <!-- <div v-if="currentNotifications.length == 0" class="no-noticitaions">{{$t('NotificationsApp.No notifications')}}</div> -->

            <!-- </CardSection> -->
          </Card>

        </LayoutSection>
      </Layout>

    </Page>
  </div>
</template>

<script>

import moment from 'moment'

export default {
  name: 'NotificationsList',
  inject: ['store'],
  data() {
    return {
      type: 'manual',
      filter: '',
      status: 'draft',
      notifications: [],
      lastLoaded: null,
    };
  },
  created() {
    if (!this.theUser.hasNotificationAccess || !this.theUser.webPushEnabled) {
      this.$router.replace('/messaging/sms/list')
    }
  },
  mounted() {
    this.loadNotifications()
    // make sure we relead notificaitons are at least 30 seconds fresh on change ...
    this.$watch('status', () => {
      if (this.lastLoaded && this.lastLoaded < Date.now() - (30 * 1000)) {
        this.loadNotifications()
      }
    })
    this.$watch('type', () => {
      this.loadNotifications()
    })
    this.$watch('$route', (to) => {
      this.status = to.params.status
      this.type = to.params.type
    })
    this.status = this.$route.params.status
    this.type = this.$route.params.type

    this.$watch('status', (newStatus) => {
      this.$router.push(`/messaging/notifications/list/type/${this.$route.params.type}/status/${newStatus}/`)
    })
  },
  computed: {
    currentNotifications() {
      let notifications = this.notifications.filter( o => o.type === this.type)
      notifications = notifications.filter((o) => {
        switch (this.status) {
          case 'draft':
            if (o.status === 'draft') return true
            break;
          case 'scheduled':
            if (o.status === 'scheduled') return true
            break;
          case 'sent':
            if (o.status === 'sending' || o.status === 'sent') return true
            break;
          case 'active':
            if (o.status === 'active') return true
            break;
          case 'paused':
            if (o.status === 'paused') return true
            break;
          case 'errored':
            if (o.status === 'errored') return true
            break;
          default:
            return false
        }
        return false
      })
      const filter = this.filter.toLowerCase().trim()
      if (filter) {
        notifications = notifications.filter(o => o.name.toLowerCase().indexOf(filter) > -1)
      }
      // added this map for datatable
      return notifications.map(n => {
        return {
          ...n,
          niceType: n.type,
          niceDomain: this.niceDomain(n.segments),
          niceLanguage: this.niceLanguage(n.segments),
          by: this.updateInfoBy(n),
          updated: n.sentOn || n.updatedOn || n.createdOn
        }
      })
    },
    numberOfDrafts() {
      return this.notifications.filter(o => o.status === 'draft' && (o.type === this.type)).length
    },
    numberOfScheduled() {
      return this.notifications.filter(o => o.status === 'scheduled' && (o.type === this.type)).length
    },
    numberOfSent() {
      return this.notifications.filter(o => (o.status === 'sending' || o.status === 'sent') && (o.type === this.type)).length
    },
    numberOfErrored() {
      return this.notifications.filter(o => (o.status === 'errored')).length
    },
    numberOfActive() {
      return this.notifications.filter(o => o.status === 'active' && (o.type === this.type)).length
    },
    numberOfPaused() {
      return this.notifications.filter(o => o.status === 'paused' && (o.type === this.type)).length
    },
    columns() {
      const rv = [{
        key: 'name',
        label: this.$t('Name'),
        fixed: true
      }]
      if (this.$route.params.type === 'manual') {
        rv.push(...[
          {
            key: 'niceDomain',
            label: this.$t('Domain'),
            maxWidth: 300
          },
          {
            key: 'niceLanguage',
            label: this.$t('Language')
          },
        ])
      }
      rv.push(...[
        {
          key: 'by',
          label: this.$t('By')
        },
        {
          key: 'updated',
          label: this.$t('Updated'),
          format: 'dateShort'
        }
      ])
      return rv
    },
  },
  methods: {
    updateInfoBy(notification) {
      return notification.sentBy || notification.updatedBy || notification.createdBy
    },
    updateInfoDate(notification) {
      // console.log(notification.sentOn || notification.updatedOn || notification.createdOn)
      // return moment().toNow(notification.sentOn || notification.updatedOn || notification.createdOn)
      return moment.utc(notification.sentOn || notification.updatedOn || notification.createdOn).local().fromNow()
    },
    firstCase(s) {
      return s.substr(0, 1).toUpperCase() + s.substr(1)
    },
    niceDomain(segments) {
      if (!segments || !segments.domain || segments.domain.length === 0) {
        return '-'
      }
      return segments.domain.join(', ')
    },
    niceLanguage(segments) {
      if (!segments || !segments.browserLanguage || segments.browserLanguage.length === 0 || segments.browserLanguage[0] === '') {
        return '-'
      }
      const lang = this.store.languages.find(o => o.key === segments.browserLanguage[0])
      if (!lang) {
        return '-'
      }
      return this.$t(`language.${lang.value}`)
    },
    updatedMessage(date, by) {
      if (!date) {
        return '-'
      }
      return `${this.niceDate(date)} <span class="name">${by}</span>`
    },
    getTabs() {
      if (this.type === 'manual') {
        return [
          { id: 'draft', label: this.$t('Draft'), badge: `${this.numberOfDrafts}` },
          { id: 'scheduled', label: this.$t('Scheduled'), badge: `${this.numberOfScheduled}` },
          { id: 'sent', label: this.$t('Sent'), badge: `${this.numberOfSent}` },
          { id: 'errored', label: this.$t('Errored'), badge: `${this.numberOfErrored}` },
        ]
      } else {
        return [
          { id: 'draft', label: this.$t('Draft'), badge: `${this.numberOfDrafts}` },
          { id: 'active', label: this.$t('Active'), badge: `${this.numberOfActive}` },
          { id: 'paused', label: this.$t('Paused'), badge: `${this.numberOfPaused}` },
        ]
      }
    },
    getActions() {
      if (!this.theUser.isDemo) {
        if (this.type === 'manual') {
          return {
            label: this.$t('NotificationsApp.New Notification'),
            onAction: () => { this.createNotification('manual') }
          }
        } else {
          return {
            label: this.$t('NotificationsApp.New Template'),
            onAction: () => { this.createNotification('template') }
          }
        }
      }
    },
    getEditNotificationUrl(notification) {
      return this.$route.params.type === 'template'
        ? `#/messaging/notifications/edit/id/${notification.notificationId}/page/details/`
        : `#/messaging/notifications/edit/id/${notification.notificationId}/page/filters/`
    },
    getRowActions(notification) {
      const rv = []
      if (!this.theUser.isDemo) {
        if (this.status === 'active' || this.status === 'draft') {
          rv.push(...[
            {
              label: this.$t('Copy'),
              onAction: () => (this.copyNotification(notification.notificationId, notification.name))
            },
            {
              label: this.$t('Delete'),
              onAction: () => (this.deleteNotification(notification.notificationId))
            }
          ])
        }
        if (this.status === 'active') {
          rv.push({
            label: this.$t('Pause'),
            onAction: () => (this.pauseNotification(notification.notificationId))
          })
        }
        if (this.status === 'paused') {
          rv.push({
            label: this.$t('Activate'),
            onAction: () => (this.activateNotification(notification.notificationId))
          })
        }
        if (this.status === 'scheduled' || this.status === 'sent') {
          rv.push(...[
            {
              label: this.$t('View'),
              onAction: () => (this.$router.push(`/messaging/notifications/edit/id/${notification.notificationId}/page/filters`))
            },
            {
              label: this.$t('Copy'),
              onAction: () => (this.copyNotification(notification.notificationId))
            }
          ])
        }
        if (this.status === 'errored') {
          rv.push({
            label: this.$t('Make Draft'),
            onAction: () => (this.makeDraftFromErrored(notification.notificationId))
          })
        } else {
          rv.push({
            label: this.$t('Rename'),
            onAction: () => (this.renameNotification(notification))
          })
        }
        if (this.status === 'scheduled') {
          rv.push({
            label: this.$t('Cancel'),
            onAction: () => (this.cancelNotification(notification))
          })
        }
      }
      return rv
    },
    loadNotifications() {
      this.lastLoaded = Date.now()
      NProgress.start()
      this.api.notifications.getNotifications()
        .then((response) => {
          this.notifications = response.notifications
        })
        .catch((error) => {
          console.error(error)
          this.apiCatch(error.message)
        })
        .finally(() => {
          NProgress.done()
        })
    },
    createNotification(notificationType) {
      const self = this
      this.$ui.prompt({
        title: self.$t('NotificationsApp.New Notification'),
        inputPlaceholder: self.$t('NotificationsApp.Notification Name'),
        inputValidator(name) {
          if (self.notifications.find(o => o.name.toLowerCase() === name.toLowerCase().trim())) {
            return self.$t('NotificationsApp.notificationExistsError')
          }
          return true
        },
        onSubmit(newName) {
          NProgress.start()
          const type = notificationType || self.$route.params.type
          self.api.notifications.getSettings()
            .then((response) => {
              let defaultIcon
              if (response.settings[0]) {
                defaultIcon = response.settings[0].defaultIcon
              }
              return self.api.notifications.createNotification(newName.trim(), type, defaultIcon)
            })
            .then((response) => {
              const newNotification = response.notifications[0]
              self.notifications.push(newNotification)
              if (type === 'template') {
                self.$router.push(`/messaging/notifications/edit/id/${newNotification.notificationId}/page/details/`)
              } else {
                self.$router.push(`/messaging/notifications/edit/id/${newNotification.notificationId}/`)
              }
            })
            .catch((error) => {
              console.error(error)
              self.apiCatch(error.message)
            })
            .finally(() => {
              NProgress.done()
            })
        }
      });
    },
    renameNotification(notification) {
      const self = this
      this.$ui.prompt({
        title: self.$t('NotificationsApp.Rename Notification'),
        inputPlaceholder: self.$t('NotificationsApp.Notification Name'),
        inputValue: notification.name,
        inputValidator(name) {
          if (self.notifications.find(o => o.name.toLowerCase() === name.toLowerCase().trim())) {
            return self.$t('NotificationsApp.notificationExistsError')
          }
          return true
        },
        onSubmit(newName) {
          NProgress.start()
          self.api.notifications.getNotification(notification.notificationId)
            .then((response) => {
              const notificationToUpdate = response.notifications[0]
              notificationToUpdate.name = newName
              return self.api.notifications.updateNotification(notificationToUpdate)
            })
            .then((response) => {
              const updatedNotification = response.notifications[0]
              self.$set(self.notifications, self.notifications.findIndex(n => n.notificationId === updatedNotification.notificationId), updatedNotification)
              self.$forceUpdate()
            })
            .catch((error) => {
              self.apiCatch(error.message)
            })
            .finally(() => {
              NProgress.done()
            })
        }
      });
    },
    deleteNotification(id) {
      const self = this
      this.$ui.confirm({
        title: self.$t('NotificationsApp.deleteMessage', [`${this.status}`]),
        onConfirm() {
          NProgress.start()
          self.api.notifications.deleteNotification(id)
            .then(() => {
              self.notifications = self.notifications.filter(o => o.notificationId !== id)
            })
            .catch((error) => {
              console.error(error)
              self.apiCatch(error.message)
            })
            .finally(() => {
              NProgress.done()
            })
        }
      })
    },
    pauseNotification(id) {
      NProgress.start()
      this.api.notifications.pauseNotification(id)
        .then((response) => {
          this.notifications = this.notifications.filter(o => o.notificationId !== id)
          this.notifications.push(response.notifications[0])
        })
        .catch((error) => {
          console.error(error)
          this.apiCatch(error.message)
        })
        .finally(() => {
          NProgress.done()
        })
    },
    activateNotification(id) {
      NProgress.start()
      this.api.notifications.activateNotification(id)
        .then((response) => {
          this.notifications = this.notifications.filter(o => o.notificationId !== id)
          this.notifications.push(response.notifications[0])
        })
        .catch((error) => {
          console.error(error)
          this.apiCatch(error.message)
        })
        .finally(() => {
          NProgress.done()
        })
    },
    cancelNotification(notification) {
      const self = this
      this.$ui.confirm({
        title: self.$t('NotificationsApp.Cancel Notification?'),
        onConfirm() {
          NProgress.start()
          self.api.notifications.getNotification(notification.notificationId)
            .then((response) => {
              const notificationToUpdate = response.notifications[0]
              notificationToUpdate.status = 'draft'
              return self.api.notifications.updateNotification(notificationToUpdate)
            })
            .then((response) => {
              const updatedNotification = response.notifications[0]
              self.$set(self.notifications, self.notifications.findIndex(n => n.notificationId === updatedNotification.notificationId), updatedNotification)
              self.$forceUpdate()
            })
            .catch((error) => {
              self.apiCatch(error.message)
            })
            .finally(() => {
              NProgress.done()
            })
        }
      });
    },
    makeDraftFromErrored(id) {
      const self = this
      NProgress.start()
      self.api.notifications.makeDraftFromErrored(id)
        .then((response) => {
          const newNotification = response.notifications[0]
          const index = self.notifications.findIndex(n => n.id === newNotification.id)
          if (index !== -1) {
            self.notifications.splice(index, 1)
            self.notifications.push(newNotification)
          }
          self.$router.push(`/messaging/notifications/list/type/${self.$route.params.type}/status/draft/`)
          .catch(this.duplicateRouteCatch)
          NProgress.done()
        })
        .catch((error) => {
          self.apiCatch(error.message)
        })
        .finally(() => {
          NProgress.done()
        })
    },
    copyNotification(id, oldName) {
      const self = this
      this.$ui.prompt({
        title: self.$t('NotificationsApp.Copy Notification?'),
        content: self.$t('NotificationsApp.Dates will be automatically changed to last 1 year'),
        inputPlaceholder: self.$t('NotificationsApp.Notification Name'),
        inputValue: oldName,
        inputValidator(name) {
          if (self.notifications.find(o => o.name.toLowerCase() === name.toLowerCase().trim())) {
            return self.$t('NotificationsApp.notificationExistsError')
          }
          return true
        },
        onSubmit(newName) {
          NProgress.start()
          self.api.notifications.copyNotification(id, newName.trim())
            .then((response) => {
              const newNotification = response.notifications[0]
              self.notifications.push(newNotification)
              self.$router.push(`/messaging/notifications/list/type/${self.$route.params.type}/status/draft/`)
              .catch(this.duplicateRouteCatch)
              NProgress.done()
            })
            .catch((error) => {
              self.apiCatch(error.message)
            })
            .finally(() => {
              NProgress.done()
            })
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
  #filter {
    display: inline-block;
    margin-right: 15px;
  }
  .btn-default .badge {
    background: #aaa;
  }
  span.name {
    display: block;
    font-size: 13px;
  }
  .no-noticitaions {
    margin: 15px;
  }
  .update-info-date {
    font-size: 80%;
    color: #666;
  }
  .section-header {
    display: flex;
  }
  .section-header-actions {
    margin-left: auto;
  }
  #filter {
    float: left;
  }
  .filter-buttons {
    float: left;
  }
</style>

